import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function Projects({ projects, onDelete, BACKEND_URL }) {
  const navigate = useNavigate();

  const handleDelete = async (projectId) => {
    if (!window.confirm("Confirm deletion of project.")) return;
    try {
      await axios.post(`${BACKEND_URL}/projects/${projectId}/delete`);
      if (onDelete) onDelete(projectId); // Notify parent to update list
    } catch (error) {
      alert("Failed to delete: " + error.message);
    }
  };

  return (
    <>
      <h2>Projecten</h2>
        <table className="projects-table">
          <thead>
            <tr>
              <th className="col-id">ID</th>
              <th className="col-date">Datum</th>
              <th className="col-name">Name</th>
              <th className="col-user">User</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {projects.map((project, idx) => (
              <tr
                key={idx}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(`/main/${project.OCAIAPP_Projects_Job_Id}`)
                }
              >
                <td className="col-id">{project.OCAIAPP_ProjectsId}</td>
                <td className="col-date">
                  {new Date(project.OCAIAPP_Projects_Entry_Date)
                    .toLocaleString("nl-NL", {
                      timeZone: "Europe/Amsterdam",
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit"
                    })}
                </td>
                <td className="col-name">{project.OCAIAPP_Projects_Name}</td>
                <td className="col-user">User</td>
                <td>
                  <span
                    title="Export"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "1.2rem",
                      marginRight: "8px"
                    }}
                    onClick={e => {
                    e.stopPropagation();
                    const url = `${BACKEND_URL}/export_detections/${project.OCAIAPP_ProjectsId}`;
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `detections_${project.OCAIAPP_ProjectsId}.csv`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    }}
                  >
                    📤
                  </span>
                  <span
                    title="Delete"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "1.2rem",
                      color: "red"
                    }}
                    onClick={e => {
                    e.stopPropagation();
                    handleDelete(project.OCAIAPP_ProjectsId);
                    }}
                  >
                    🗑️
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
    </>
  );
}